import ErrorBox from '@components/common/ErrorBox';
import UploadFiles from '@components/common/UploadFiles';
import Accordion from '@ui/accordion/Accordion';
import AccordionItem from '@ui/accordion/AccordionItem';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import DwFormFieldPhoneWithPrefix from '@ui/formfield/DwFormFieldPhoneWithPrefix';
import addressutils from '@utils/addressutils';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import RegisterForm from '@components/login/RegisterForm';
import RegisteredInStoreCheckoutConfirm from '@components/login/RegisteredInStoreCheckoutConfirm';
import ProfileNameFields from '@components/account/ProfileNameFields';
import ReCAPTCHA from 'react-google-recaptcha';
import GiftcardBalanceFAQ from './GiftcardBalanceFAQ';
const focusOnError = createDecorator(); // must be outside the component
const ContactUsForm = (props) => {
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [userData, setUserData] = useState();
    const [faqs, setFaqs] = useState([]);
    // const [fetchForm, setFetchForm] = useState(false);
    const [filename, setFilename] = useState(undefined);
    const [showOrderNumber, setShowOrderNumber] = useState(false);
    const [locale, setLocale] = useState(`${window.language}_${window.country}`);
    const [showForm, setShowForm] = useState(true);
    const [loginStep, setLoginStep] = useState();
    const [loginEmail, setLoginEmail] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [localName, setLocalName] = useState();
    const [localSurname, setLocalSurname] = useState();
    const [phone, setPhone] = useState();
    const [phonePrefix, setPhonePrefix] = useState();
    const reCaptchaRef = useRef();
    const showRecaptcha = window.recapchaCfg && JSON.parse(window.recapchaCfg).loginButton;
    const formDefinitionType = window.isClothing ? 'contactUsClothing' : 'contactUs';
    const orderNumberByReasonMap = {
        Payment: true,
        Shipping: true,
        'Returns And Refunds': true,
        mbm: true,
    };
    useEffect(() => {
        if (window.loggedin) {
            api.getProfile().then((data) => {
                setFirstName(data.firstName);
                setLastName(data.lastName);
                setPhone(data.phone);
                setPhonePrefix(data.phonePrefix);
                setLoginEmail(data.email);
            });
        }
    }, []);
    useEffect(() => {
        customEventBus.on('contacts:selected-country', (data) => {
            var _a;
            setLocale(`${window.language}_${data.countryCode}`);
            setShowForm(!!((_a = data.csdata.contactCenter) === null || _a === void 0 ? void 0 : _a.enableWeb));
        });
        api.GetContactsByCountry(window.country).then((data) => {
            var _a;
            if (data && ((_a = data.contactCenter) === null || _a === void 0 ? void 0 : _a.enableWeb)) {
                let val = {};
                api.getForm(formDefinitionType, val).then((data) => {
                    setInitialValues(val);
                    if (val.contactreason) {
                        selectContactReason(val.contactreason);
                    }
                    if (!props.mbmReasonActive) {
                        data.contactreason.options = data.contactreason.options.filter((opt) => opt.value != 'mbm');
                    }
                    if (!props.giftCardActive) {
                        data.contactreason.options = data.contactreason.options.filter((opt) => opt.value != 'giftcard');
                    }
                    const orderedData = Object.assign({}, data);
                    orderedData.contactreason.options.sort((a, b) => {
                        if (a.value && b.value) {
                            const A = a.label.toUpperCase();
                            const B = b.label.toUpperCase();
                            return A.localeCompare(B);
                        }
                    });
                    setFormdef(orderedData);
                });
            }
            else {
                setShowForm(false);
            }
        });
    }, []);
    const onFileChange = () => {
        let val = {};
        api.getForm(formDefinitionType, val).then((data) => {
            setInitialValues(val);
            setFormdef(data);
        });
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        values.file1 = filename;
        if (showRecaptcha) {
            const token = await reCaptchaRef.current.executeAsync();
            values.gr3Token = token;
        }
        if (!window.isClothing) {
            values.locale = locale;
        }
        api
            .checkLogin(values)
            .then((data) => {
            if (data.success) {
                if (!window.loggedin) {
                    setLoginEmail(values.email);
                    setFirstName(values.firstname);
                    setLastName(values.lastname);
                    if (values.localname && values.localsurname) {
                        setLocalName(values.localname);
                        setLocalSurname(values.localsurname);
                    }
                }
                setPhone(values.phone);
                setPhonePrefix(values.phonePrefix);
                if (data.exist && data.hasAvailableLoginMethods) {
                    //check account creato in Store
                    if (data.isCreatedInStore && !data.hasChangedPassword) {
                        if (data.hasSentCompleteProfileEmail) {
                            setLoginStep('registeredInStore');
                        }
                        else {
                            setLoginStep('registeredInStoreSendEmail');
                        }
                    }
                }
                else {
                    // NON esiste account con questa mail
                    setLoginStep('register');
                }
            }
        })
            .catch((e) => {
            setErrors([e]);
        });
        setUserData({ title: values.title, firstname: values.firstname, lastname: values.lastname });
        return api
            .contactUsSubmit(values, formdef)
            .then((data) => {
            if (data.success) {
                setSubmitted(true);
                const select = document.querySelector('.cs-form-container');
                const header = document.querySelector('header').offsetHeight;
                window.scrollTo({
                    top: select.offsetTop - header,
                    behavior: 'smooth',
                });
                select.focus();
            }
            if (data.error && data.error.length > 0) {
                setErrors(data.error);
            }
            if (!formutils.checkValidationAfterSubmit(data, errors)) {
                return errors;
            }
            analytics.contactUsTwo();
        })
            .catch((e) => setErrors([e]));
    };
    const validate = async (values) => {
        if (window.loggedin) {
            values.privacyFlag = true;
        }
        return await formutils.validateForm(values, formdef, formDefinitionType);
    };
    const selectContactReason = (reason) => {
        if (reason != '') {
            api.contactUsFaqs(reason).then((data) => !!data && setFaqs(data));
            setShowOrderNumber(!!orderNumberByReasonMap[reason]);
        }
        else {
            setFaqs([]);
            setShowOrderNumber(false);
        }
    };
    const selectFilenameUploaded = (fileName) => {
        formdef['file1'].htmlValue = fileName;
        setFilename(fileName);
    };
    if (!formdef || !showForm) {
        return React.createElement(React.Fragment, null);
    }
    const getHtmlContent = (str) => {
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: str } });
    };
    return (React.createElement("div", { className: "contact-us__form" },
        !submitted && React.createElement("h2", { className: (props === null || props === void 0 ? void 0 : props.fromModal) ? 'dialog__title' : 'contact-us__form-title' }, t('contactus.contactform')),
        submitted ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "contact-us__submit-message mb-32" },
                React.createElement("p", { className: "primary-m-u mb-24" }, t('contactus.thankyou')),
                window.country != 'JP' && t('contactus.dear'),
                " ",
                addressutils.salutation(userData.firstname, userData.lastname, formutils.labelByValue(userData.title, formdef === null || formdef === void 0 ? void 0 : formdef.title)),
                '. ',
                t('contactus.salutation'),
                React.createElement("br", null),
                t('contactus.wewillcontactyousoon'),
                window.loggedin && (React.createElement("div", { className: "container-button-back col-6" },
                    React.createElement("a", { href: window.homeurl, className: "button button--primary d-inline-block " }, t('button.backtoshopping'))))),
            React.createElement("div", { className: "wrapper-login" },
                loginStep == 'register' && (React.createElement(RegisterForm, { inContactUs: true, phone: phone, localName: localName, localSurname: localSurname, phonePrefix: phonePrefix, firstName: firstName, lastName: lastName, loginEmail: loginEmail })),
                (loginStep == 'registeredInStoreSendEmail' || loginStep == 'registeredInStore') && React.createElement(RegisteredInStoreCheckoutConfirm, { email: loginEmail })))) : (React.createElement(React.Fragment, null,
            !(props === null || props === void 0 ? void 0 : props.fromModal) && (React.createElement("div", { className: "row justify-center" },
                React.createElement("div", { className: "col-lg-8 col-12 contact-us__description" }, t('contactus.intro')))),
            React.createElement(Form, { onSubmit: onSubmit, validate: validate, initialValues: initialValues, decorators: [focusOnError], render: ({ handleSubmit, form, submitting, pristine, values }) => {
                    var _a;
                    return (React.createElement("form", { onSubmit: handleSubmit },
                        !window.loggedin && !firstName && !lastName && React.createElement(ProfileNameFields, { formdef: formdef }),
                        React.createElement("div", { className: "row" }, !window.loggedin && !loginEmail && (React.createElement("div", { className: "col-12" },
                            React.createElement(DwFormField, { def: formdef, name: "email", autocomplete: "email", validTick: true })))),
                        !window.loggedin && React.createElement(DwFormFieldPhoneWithPrefix, { def: formdef, hideHelperText: true, uniqueLabel: t('profile.phonenumber') }),
                        React.createElement(DwFormField, { def: formdef, name: "country", autocomplete: "country", type: ((_a = formdef === null || formdef === void 0 ? void 0 : formdef.country) === null || _a === void 0 ? void 0 : _a.options) ? 'select' : 'text' }),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-12" },
                                React.createElement(DwFormField, { def: formdef, name: "contactreason", type: "select", onChange: (e) => selectContactReason(e.target.value) }))),
                        faqs.length > 0 && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "row justify-center" },
                                React.createElement("div", { className: "col-lg-8 col-12 contact-us__description" }, t('contactus.seefaq'))),
                            React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "contact-us__faqs" },
                                    React.createElement(Accordion, null, faqs === null || faqs === void 0 ? void 0 : faqs.map((f, i) => (React.createElement(AccordionItem, { key: f.title, title: getHtmlContent(f.title), accordionId: f.title, itemClass: "faq--card", headerClass: "accordion__header--lc" },
                                        React.createElement("div", { className: "faq--card-body" }, getHtmlContent(f.content)))))))))),
                        showOrderNumber && (React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-12" },
                                React.createElement(DwFormField, { def: formdef, name: "ordernumber" })))),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-12" },
                                React.createElement(DwFormField, { def: formdef, name: "message", type: "textarea" })),
                            React.createElement("div", { className: "col-12 mb-12" },
                                React.createElement(UploadFiles, { formfield: "contactUs.file1", label: formdef['file1'].label, uploadedFile: filename, filetype: "IMAGES", onFileChange: onFileChange, tooltipText: t('contactus.imagetooltip'), selectedFile: selectFilenameUploaded }))),
                        !window.loggedin && (React.createElement("div", { className: "mb-16 mt-16 row" },
                            React.createElement("div", { className: "col-12" },
                                React.createElement(DwFormField, { def: formdef, type: "checkbox", name: "privacyFlag" })))),
                        window.loggedin && (React.createElement("div", { className: "wrapper-info mt-32" },
                            React.createElement("div", { className: "row mb-20" },
                                React.createElement("span", { className: "primary-xs-u col-4" }, t('profile.namesurname')),
                                React.createElement("span", { className: "bold col-8" },
                                    firstName,
                                    " ",
                                    lastName)),
                            React.createElement("div", { className: "row mb-20" },
                                React.createElement("span", { className: "primary-xs-u col-4" }, t('profile.email')),
                                React.createElement("span", { className: "bold col-8" }, loginEmail)),
                            phone && (React.createElement("div", { className: "row mb-20" },
                                React.createElement("span", { className: "primary-xs-u col-4" }, t('profile.phonenumber')),
                                React.createElement("span", { className: "bold col-8" },
                                    phonePrefix,
                                    " ",
                                    phone))),
                            !phone && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "mb-12" },
                                    React.createElement("span", null, t('profile.additionalinfo'))),
                                React.createElement(DwFormFieldPhoneWithPrefix, { def: formdef, uniqueLabel: t('profile.phonenumber') }))))),
                        React.createElement("div", { className: "row" }, (props === null || props === void 0 ? void 0 : props.fromModal) ? (React.createElement("div", { className: "col-12" },
                            React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'] }, t('button.submit')))) : (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "col-sm-6 d-none d-sm-flex " }),
                            React.createElement("div", { className: "col-sm-6" },
                                showRecaptcha && React.createElement(ReCAPTCHA, { className: "recaptcha", sitekey: window.atob(window.recapchaData), size: "invisible", ref: reCaptchaRef }),
                                React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'] }, t('button.submit')))))),
                        React.createElement(ErrorBox, { errors: errors })));
                } }))),
        React.createElement(GiftcardBalanceFAQ, { results: faqs })));
};
export default ContactUsForm;
